import axios from 'axios';
import { authContext, adalConfig } from './adal';
import { BaseUrl } from '../constants';

export const FhirInstance = axios.create({
  baseURL: BaseUrl,
});

const getAuthToken = async () => {
  const tsk = new Promise((resolve, reject) => {
    if (!adalConfig.endpoints) throw new Error('Endpoints is missing');
    authContext.acquireToken(adalConfig.endpoints.fhir, (error, token) =>
      error ? reject(error) : resolve(token),
    );
  });
  return await tsk;
};

FhirInstance.interceptors.request.use(async config => {
  if (!adalConfig.endpoints) throw new Error('Endpoints is missing');
  const tokenResponse = await getAuthToken();
  config.headers.Authorization = `Bearer ${tokenResponse}`;
  return config;
});
